import { EnomSelectedExercise } from "../../components/AddBlockProgram/EmomBlockProgramForm/EmomBlockProgramForm";
import { IEndpoints } from "../../hooks/useEndpoints";
import { Exercise } from "../../models/Exercise";
import { MeState } from "../../store/reducers/me";

interface TimeComponents {
  hours: number;
  mins: number;
  secs: number;
}
export const toTwoDigitString = (number: number) => {
  if (number < 10) {
    return `0${number}`;
  }
  return `${number}`;
};

export const secondsToTime = (seconds: number): TimeComponents => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return {
    hours,
    mins,
    secs: remainingSeconds,
  };
};

export const timeToSeconds = (time: TimeComponents): number => {
  const { hours, mins, secs } = time;
  return hours * 3600 + mins * 60 + secs;
};

export const formatTimeComponents = (time: TimeComponents): string => {
  const { hours, mins, secs } = time;

  // Formatta ore, minuti e secondi per avere sempre due cifre
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = mins.toString().padStart(2, "0");
  const formattedSeconds = secs.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const getUniqueUnits = (
  exercise: EnomSelectedExercise | undefined,
  labelUnits: {
    label: string;
    value: string;
  }[],
  index: number
) => {
  if (!exercise) return [];
  const units = exercise.config?.flatMap((item, indexItem) =>
    indexItem === index ? [] : item.unit
  );
  return labelUnits.filter((item) => !units?.includes(item.value));
};
export const getUniqueConfigUnits = (
  config: ({
    unit: string | undefined;
    value: number | undefined;
  } & object)[],
  labelUnits: {
    label: string;
    value: string;
  }[],
  index: number
) => {
  const units = config?.flatMap((item, indexItem) =>
    indexItem === index ? [] : item.unit
  );
  return labelUnits.filter((item) => !units?.includes(item.value));
};

export const genericLoadOptions =
  (
    endpoint: IEndpoints[keyof IEndpoints],
    callback: (item: any) => any,
    customParams: object = {},
    onError?: (error: unknown) => void
  ) =>
  async (search: string) => {
    return new Promise<object[]>(async (resolve) => {
      try {
        const { data } = await (endpoint as any)({
          ...(search ? { search } : {}),
          ...customParams,
          limit: 20,
          page: 0,
        });
        resolve(data.docs.map(callback));
      } catch (error) {
        onError?.(error);
        resolve([]);
      }
    });
  };

export const addBaseUrl = (type: 1, url?: string) => {
  if (!url) return url;
  const base = {
    1: process.env.REACT_APP_BASE_URL_IMAGE,
  }[type];
  return `${base}${url}`;
};

export const getLabelFromOptions = (
  array: { label: string; value: string }[],
  value: any
) => {
  return array?.find?.((item) => item.value === value)?.label || "error";
};
